module.exports = __webpack_public_path__ + "img/FreshBooks.e1466a61.svg";